import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { GamificationStatusEnum } from "../../../generated/graphql/types";
import { useGetUserSummaryGamificationQueryQuery } from "./graphql/get-user-summary-gamification-query.v5.generated";
var CREHANA_COINS_NAME = 'CrehanaCoins';
export var useGetUserSummaryGamification = function useGetUserSummaryGamification(_ref) {
  var _data$gamification_v;
  var organizationId = _ref.organizationId;
  var _useGetUserSummaryGam = useGetUserSummaryGamificationQueryQuery({
      variables: {
        input: {
          organization_id: organizationId
        }
      },
      context: {
        clientName: 'v5'
      }
    }),
    data = _useGetUserSummaryGam.data,
    loading = _useGetUserSummaryGam.loading,
    error = _useGetUserSummaryGam.error,
    refetch = _useGetUserSummaryGam.refetch;
  var handleRefetch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return refetch();
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            throw _context.t0;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function handleRefetch() {
      return _ref2.apply(this, arguments);
    };
  }();
  var summaryResponse = data === null || data === void 0 ? void 0 : (_data$gamification_v = data.gamification_v2) === null || _data$gamification_v === void 0 ? void 0 : _data$gamification_v.get_allowed_user_summary_by_collaborator;
  if ((summaryResponse === null || summaryResponse === void 0 ? void 0 : summaryResponse.__typename) === 'AllowedUserSummaryUserSummaryResponse') {
    var _detail$stats$availab, _detail$currency_poin;
    var detail = summaryResponse.detail;
    var crehanaCoinsCurrentUser = (_detail$stats$availab = detail === null || detail === void 0 ? void 0 : detail.stats.available_points) !== null && _detail$stats$availab !== void 0 ? _detail$stats$availab : 0;
    var currencyCustomName = (_detail$currency_poin = detail === null || detail === void 0 ? void 0 : detail.currency_point_name) !== null && _detail$currency_poin !== void 0 ? _detail$currency_poin : CREHANA_COINS_NAME;
    var hasCurrency = (detail === null || detail === void 0 ? void 0 : detail.currency_point_status) === GamificationStatusEnum.Published;
    return {
      crehanaCoinsCurrentUser: crehanaCoinsCurrentUser,
      currencyCustomName: currencyCustomName,
      hasCurrency: hasCurrency,
      loading: loading,
      error: error,
      refetch: handleRefetch
    };
  }
  return {
    crehanaCoinsCurrentUser: 0,
    currencyCustomName: CREHANA_COINS_NAME,
    hasCurrency: false,
    loading: loading,
    error: error,
    refetch: handleRefetch
  };
};